import { compose, setPropTypes, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  addIntlProps,
  addProps,
  renderNothingIfPropFalsy,
} from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';
import combineSelectors from 'utils/combineSelectors';
import {
  currentSelectedQuantity,
  inCartQuantity,
  modelSubmittedTotalWorkingStateCalculated,
  totalQuota,
  unsubmittedQuota,
} from 'reducers/models/selectors';
import { theme } from 'reducers/dashboard/selectors';
import { updateModelWorkingState } from 'reducers/models/actions';
import styles from './styles.module.scss';
import { getCurrentUser } from 'utils/localStorage';

const propTypes = {
  modelId: PropTypes.string,
  modelWorkingStateDenormalized: PropTypes.object,
  seriesDetailPageLoaded: PropTypes.bool,
};

const mapStateToProps = combineSelectors({
  inCartQuantity,
  unsubmittedQuota,
  theme,
  modelSubmittedTotalWorkingStateCalculated,
  totalQuota,
  currentSelectedQuantity,
});

const mapDispatchToProps = {
  updateModelWorkingState,
};

export const hasQuantityAndPriority = priorityQuantityMapping => {
  if (priorityQuantityMapping['n/a'] > 0) {
    return false;
  }
  const quantity = Object.values(priorityQuantityMapping).reduce(
    (accumulator, currentQuantity) => accumulator + currentQuantity,
    0,
  );
  return quantity > 0;
};

export const changeStatuses = (workingState, templateId) => {
  const statusesChangedWorkingState = { ...workingState };
  let currentUser = getCurrentUser();

  statusesChangedWorkingState.templatesWorkingState.forEach(template => {
    if (hasQuantityAndPriority(template.prioritiesToQuantitiesMap)) {
      template.status = 'inCart';
      template.addedBy = currentUser;
    }
  });
  return statusesChangedWorkingState;
};

export const addAllToCart = ({
  modelWorkingStateDenormalized,
  updateModelWorkingState,
}) => () => {
  const newWorkingState = changeStatuses(modelWorkingStateDenormalized);
  updateModelWorkingState(newWorkingState);
};

export const buttonStyle = ({ disabled }) =>
  disabled ? styles.inactiveButton : styles.button;

export const buttonString = ({ locked, addAllString, lockedString }) =>
  locked ? lockedString : addAllString;

// TODO: Once IPA data inconsistency is resolved, then we can use remainingQuota
// Until then, we calculate remainingQuota
export const disabled = ({
  locked,
  inCartQuantity,
  modelSubmittedTotalWorkingStateCalculated,
  currentSelectedQuantity,
  totalQuota,
}) => {
  const remainingQuota =
    totalQuota - modelSubmittedTotalWorkingStateCalculated - inCartQuantity;
  return (
    locked ||
    remainingQuota === 0 ||
    currentSelectedQuantity - inCartQuantity > remainingQuota
  );
};

export const themeStyle = ({ disabled, theme }) =>
  disabled
    ? null
    : {
        background: theme.palette.primary,
      };

export default compose(
  setPropTypes(propTypes),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['addAllString', 'lockedString'],
  }),
  withHandlers({ addAllToCart }),
  addProps({
    disabled,
  }),
  addProps({
    buttonStyle,
    buttonString,
    themeStyle,
  }),
  renderNothingIfPropFalsy('seriesDetailPageLoaded'),
);
